import { gql } from "@apollo/client";

export const DECLINE_INVITATION = gql`
  mutation DeclineInvitation($invitationMrn: ID!) {
    declineInvitation(invitationMrn: $invitationMrn)
  }
`;
